import React from 'react';
import BulkPricingSection from './BulkPricingSection';
import { PriceTier } from '../../types';
import CartActionsSection from './CartActionsSection';
import { SizeQuantity } from '@flooron/shared';
import './ProductInfoGrid.css';

interface ProductInfoGridProps {
  priceTiers: PriceTier[];
  currentQuantity: number;

  brand?: string | null;
  tags?: string[] | null;

  currentPrice: number;
  quantity: number;
  totalPrice: number;
  availableQuantity: number;
  favoriteCount: number;
  isFavorite: boolean;
  sizeQuantities?: SizeQuantity[];
  sizeQuantitiesState?: Record<string, number>;
  generalQuantity?: number;

  onGeneralQuantityChange?: (qty: number) => void;
  onSizeQuantityChange?: (size: string, qty: number) => void;
  getPriceForQuantity?: (qty: number) => number;
  onToggleFavorite: () => void;
  onAddToCart: () => void;
  onBuyNow: () => void;
}

const ProductInfoGrid: React.FC<ProductInfoGridProps> = ({
  priceTiers,
  currentQuantity,
  currentPrice,
  quantity,
  totalPrice,
  availableQuantity,
  favoriteCount,
  isFavorite,
  sizeQuantities,
  sizeQuantitiesState,
  generalQuantity,
  onGeneralQuantityChange,
  onSizeQuantityChange,
  getPriceForQuantity,
  onToggleFavorite,
  onAddToCart,
  onBuyNow,
}) => {
  return (
    <div className="product-info-grid">

      {/* FULL WIDTH – Bulk Pricing with Price Info */}
      <div className="bulk-pricing-container">
        <BulkPricingSection
          priceTiers={priceTiers}
          currentQuantity={currentQuantity}
          currentPrice={currentPrice}
          quantity={quantity}
          totalPrice={totalPrice}
          sizeQuantities={sizeQuantities}
          availableQuantity={availableQuantity}
          sizeQuantitiesState={sizeQuantitiesState}
          generalQuantity={generalQuantity}
          onGeneralQuantityChange={onGeneralQuantityChange}
          onSizeQuantityChange={onSizeQuantityChange}
          getPriceForQuantity={getPriceForQuantity}
        />
      </div>

      {/* FULL WIDTH – Cart Actions */}
      <div className="cart-actions-container">
        <CartActionsSection
          availableQuantity={availableQuantity}
          selectedQuantity={quantity}
          favoriteCount={favoriteCount}
          isFavorite={isFavorite}
          onToggleFavorite={onToggleFavorite}
          onAddToCart={onAddToCart}
          onBuyNow={onBuyNow}
        />
      </div>

    </div>
  );
};

export default ProductInfoGrid;
